module.exports = {
  siteTitle: "O2Explorer - Exploring Origami Owl with Jonathan Gin", // <title>
  shortSiteTitle: "O2Explorer - Exploring Origami Owl with Jonathan Gin", // <title> ending for posts and pages
  siteDescription: "O2Explorer - Exploring Origami Owl with Jonathan Gin",
  siteUrl: "https://O2Explorer.com",
  pathPrefix: "",
  siteImage: "preview.jpg",
  siteLanguage: "en",
  // author
  authorName: "Jonathan Gin",
  authorTwitterAccount: "icaninspireme",
  // info
  headerTitle: "Jonathan Gin",
  headerSubTitle: "exploring Origami Owl",
  // manifest.json
  manifestName: "O2Explorer - Exploring Origami Owl with Jonathan Gin",
  manifestShortName: "O2Explorer", // max 12 characters
  manifestStartUrl: "/index.html",
  manifestBackgroundColor: "white",
  manifestThemeColor: "#666",
  manifestDisplay: "standalone",
  // social
  authorSocialLinks: [
    { name: "twitter", url: "https://twitter.com/icaninspireme" },
    { name: "instagram", url: "https://instagram.com/icaninspireme" },
    { name: "facebook", url: "http://facebook.com/jonathangin" }
  ]
};



// WEBPACK FOOTER //
// ./content/meta/config.js